exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dingding-icon.checked .icon{color:#0c64eb}.swb-logo-icon{width:46px;height:46px;background:#606266;text-align:center;border-radius:50%;padding:10px;margin-left:30px;cursor:pointer}.swb-logo-icon.checked{background:#0c64eb}.swb-logo-icon img{width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-48cd93f0","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/compo/oaAudit/AuditType.vue
// module id = 2551
// module chunks = 0